import { State } from '@/store/store'

export class WorkingTimeState {
  public list: WorkingTimeList
  public create: object
  public update: object
  public delete: object

  constructor() {
    this.list = {
      data: [],
      itemCount: 0,
    }
    this.create = {}
    this.update = {}
    this.delete = {}
  }
}
export interface WorkingTimeList {
  data: IWorkingTime[],
  itemCount: number
}
export interface IWorkingTime {
  _id?: string,
  jobTypes: string[],
  patientTypes: string[],
  period: string,
  price: number,
  food: number,
  startTime: string,
  endTime: string,
}

export default WorkingTimeState
